import { render, staticRenderFns } from "./server.create.vue?vue&type=template&id=23946dec&"
import script from "./server.create.vue?vue&type=script&lang=ts&"
export * from "./server.create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports